import { z } from 'zod';

export const apiTokenSchema = z.object({
  id: z.string(),
  name: z.string(),
  tokenPrefix: z.string(),
  /** The AgencyUsers row this token is vinculated to — fixes its agency + permissions at issuance. */
  agencyUserId: z.string(),
  userId: z.string(),
  userEmail: z.string(),
  userDisplayName: z.string(),
  role: z.enum(['admin', 'member', 'client', 'system']),
  lastUsedAt: z.coerce.date().nullable(),
  revokedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
});
export type ApiTokenSchema = z.infer<typeof apiTokenSchema>;

/** Returned only from the create endpoint — the raw secret is never persisted or shown again. */
export const apiTokenIssuedSchema = apiTokenSchema.extend({ token: z.string() });
export type ApiTokenIssuedSchema = z.infer<typeof apiTokenIssuedSchema>;
